export default __webpack_public_path__ + "static/media/H1009.a2cd0c0e.mp3";